@if (availableSlotsLoaded()) {
  <div class="appointment" [class.appointment--without-sunday]="!includeSunday">
    @if (availableSlots().status === "OK") {
      @if (storePhoneNumber(); as phone) {
        <div class="appointment-title">
          Aucun créneau ne vous convient ? Contactez-nous au
          <a href="tel:{{ phone }}">{{ phone }}</a>
        </div>
      }
      <div class="appointment-nav">
        @if (firstWeekDay() > 0) {
          <i
            (click)="onPrev()"
            [color]="'GREY_ALPHA'"
            [iconName]="'ARROW_LEFT'"
            [size]="'2rem'"
            class="appointment-nav-arrow-left"></i>
        }
        <div #daysElementsRef class="appointment-nav-days">
          @for (item of availableSlots().slots | splitArrayBy: daysPerPage; track item; let i = $index) {
            @for (
              day of dateArray().slice(i * daysPerPage, (i + 1) * daysPerPage);
              track day;
              let index = $index;
              let first = $first;
              let last = $last
            ) {
              <div
                [class.appointment-nav-day--inactive]="!(item | isDateIsAvailable: index)"
                [class.appointment-nav-day--selected]="day | isDateSelected: dateSelected()"
                [class.appointment-nav-day-first]="first"
                [class.appointment-nav-day-last]="last"
                class="appointment-nav-day">
                <div (click)="selectedDate(day)" class="day">
                  <span class="day-name">{{ day | date: "EEE" | titlecase }}</span>
                  <span class="day-number">{{ day | date: "dd" }}</span>
                  <span class="day-month">{{ day | date: "LLL" | titlecase }}</span>
                </div>
              </div>
            }
          }
        </div>
        @if (firstWeekDay() < DISPLAYED_WEEKS - 1) {
          <i
            (click)="onNext()"
            [color]="'GREY_ALPHA'"
            [iconName]="'ARROW_RIGHT'"
            [size]="'2rem'"
            class="appointment-nav-arrow-right"></i>
        }
      </div>
      <div #schedulesElementRef class="appointment-schedules">
        @for (item of availableSlots().slots | splitArrayBy: daysPerPage; track item; let i = $index) {
          @for (
            day of availableSlots().slots.slice(i * daysPerPage, (i + 1) * daysPerPage);
            track day;
            let first = $first;
            let last = $last
          ) {
            <div
              [class.appointment-schedules-day-first]="first"
              [class.appointment-schedules-day-last]="last"
              class="appointment-schedules-day">
              @for (schedule of day.schedules | arrayLength: 6; track $index) {
                <span class="appointment-schedules-schedule">
                  @if (schedule && schedule.start && schedule.end) {
                    <span (click)="selectSchedules(day.date, schedule)" class="time">{{ schedule.start }}</span>
                  } @else {
                    <span class="time--fake"></span>
                  }
                </span>
              }
            </div>
          }
        }
      </div>
    } @else {
      <div class="unavailable">
        <h2 class="unavailable-title">{{ availableSlots().message?.title }}</h2>
        <div class="unavailable-body">
          <p [innerHTML]="availableSlots().message?.bodyHtml"></p>
          @if (availableSlots().cta; as cta) {
            <app-button [label]="cta.label" [theme]="'FULL_WHITE'" [url]="cta.url" />
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div class="loading">
    <div class="spinner spinner--white"></div>
  </div>
}
